<!--
 * @Description: 
 * @Date: 2021-07-19 16:35:52
-->
<template>
  <div class="box">
    <el-form :model="formParams" ref="form">
      <div class="flex" v-for="{ title, subTitle, list } in form" :key="title">
        <div class="app-detail-item-title">
          <span>{{ title }}</span>
          <span
            style="font-size: 12px;margin-top: 4px;margin-left: 5px;color:#9c9c9c;"
          >
            {{ subTitle }}
          </span>
        </div>
        <el-form-item
          :label="item.label"
          v-for="item in list"
          :label-width="item.label ? '120px' : '0'"
          :style="{ width: item.width }"
          :key="item.key"
          :prop="item.key"
          :rules="item.rules || []"
        >
          <template v-if="item.slot === 'dicSelect'">
            <dic-select
              @dic-select-obj="
                val => {
                  formParams[item.key] = val.enterpriseId;
                }
              "
              :fuzzyDef="() => {}"
              :prop="{
                label: 'enterpriseName',
                code: 'enterpriseId'
              }"
              :ajaxQueryObj="{}"
              ajaxQuery="enterpriseName"
              :placeholder="item.placeholder"
              class="data-item"
            ></dic-select>
          </template>
          <template v-if="item.slot === 'input'">
            <el-tooltip
              class="item"
              effect="dark"
              :content="formParams[item.key]"
              :disabled="!(item.attrs || {}).disabled || !formParams[item.key]"
              placement="top-start"
            >
              <el-input
                :placeholder="item.placeholder"
                v-model="formParams[item.key]"
                v-bind="item.attrs"
                class="data-item"
              />
            </el-tooltip>
          </template>
          <template v-if="item.slot === 'date'">
            <el-date-picker
              :placeholder="item.placeholder"
              :value-format="item.valueFormat"
              v-model="formParams[item.key]"
              class="data-item"
              :type="item.type || 'month'"
            ></el-date-picker>
          </template>
          <template v-if="item.slot === 'custom'">
            <component
              :ref="item.ref"
              :is="item.component"
              :value="formParams[item.key]"
              v-bind="item.attrs"
              v-on="item.listener"
            ></component>
          </template>
        </el-form-item>
      </div>
    </el-form>
    <div style="text-align: center;padding-bottom:15px;">
      <el-button type="primary" @click="edit">
        {{ isEdit ? '保存' : '编辑' }}
      </el-button>
      <el-button @click="$xrkDialog.remove()">关闭</el-button>
    </div>
  </div>
</template>

<script>
import { invoice } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
export default {
  name: 'add-dutypaid-proof',
  components: { dicSelect },
  props: { id: [Number, String] },
  data() {
    return {
      isEdit: false,
      formParams: {
        address: []
      }
    };
  },
  computed: {
    form() {
      const {
        $confirm,
        isEdit,
        formParams: { address }
      } = this;

      const validateTel = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系电话不能为空'));
        } else if (!/^[0-9]+$/.test(value)) {
          callback(new Error('联系电话必须是数字'));
        } else {
          callback();
        }
      };
      const inputRequired = [
        { required: true, message: '请输入内容', trigger: 'change' }
      ];
      return [
        {
          title: '发票信息',
          list: [
            {
              label: '客户企业',
              slot: 'input',
              key: 'enterpriseName',
              attrs: {
                disabled: true
              }
            },
            {
              label: '纳税人识别号',
              slot: 'input',
              key: 'enterpriseIdentifierNo',
              attrs: {
                maxlength: 20,
                disabled: !isEdit
              },
              rules: inputRequired
            },
            {
              label: '联系电话',
              slot: 'input',
              key: 'enterprisePhone',
              attrs: {
                disabled: !isEdit
              },
              rules: [
                ...inputRequired,
                {
                  validator: validateTel,
                  trigger: 'blur'
                }
              ]
            },
            {
              label: '开户银行',
              slot: 'input',
              key: 'openBank',
              attrs: {
                maxlength: 30,
                disabled: !isEdit
              },
              rules: inputRequired
            },
            {
              label: '银行账号',
              slot: 'input',
              key: 'bankNo',
              attrs: {
                maxlength: 19,
                disabled: !isEdit
              },
              rules: inputRequired
            },
            {
              label: '企业地址',
              slot: 'input',
              key: 'enterpriseAddress',
              attrs: {
                maxlength: 30,
                disabled: !isEdit
              },
              rules: inputRequired
            }
          ]
        },
        {
          title: '发票邮寄地址',
          subTitle: '请认真填写发票邮寄地址，如出现邮寄错误，发票将无法找回。',
          list: [
            {
              width: '100%',
              slot: 'custom',
              ref: 'addressForm',
              component: {
                render() {
                  const maxCount = 5;
                  const formItemStyle =
                    'width: 250px;margin-bottom: 15px;margin-right: 25px;';
                  return (
                    <div>
                      {address.map((item, index) => {
                        return (
                          <div style="border: 1px dashed #d0d0d0;padding: 15px 15px 5px 15px;margin-bottom:25px;">
                            <div>
                              <span style="font-size: 18px;font-weight: bold;">
                                {item.addressName}
                              </span>
                              <el-button
                                style="margin-left:5px;"
                                type="text"
                                disabled={item.isDefault != 0 || !isEdit}
                                onClick={() => {
                                  if (!item.isDefault) {
                                    address.forEach(i => (i.isDefault = 0));
                                    item.isDefault = 1;
                                  }
                                }}
                              >
                                {item.isDefault ? '默认地址' : '设为默认地址'}
                              </el-button>
                              <el-button
                                style="float:right;"
                                type="text"
                                disabled={!isEdit}
                                onClick={() => {
                                  $confirm('是否删除该地址', {}).then(() => {
                                    address.splice(index, 1);
                                  });
                                }}
                              >
                                删除
                              </el-button>
                            </div>
                            <el-form
                              style="display:flex;flex-wrap: wrap;"
                              ref={`addressForm${index}`}
                              props={{ model: item }}
                            >
                              <el-form-item
                                label="收件地址名称"
                                style={formItemStyle}
                                prop="addressName"
                                rules={inputRequired}
                              >
                                <el-input
                                  v-model={item.addressName}
                                  disabled={!isEdit}
                                />
                              </el-form-item>
                              <el-form-item
                                label="收件人"
                                style={formItemStyle}
                                prop="receiptFullName"
                                maxlength="10"
                                rules={inputRequired}
                              >
                                <el-input
                                  v-model={item.receiptFullName}
                                  disabled={!isEdit}
                                />
                              </el-form-item>
                              <el-form-item
                                label="联系电话"
                                style={formItemStyle}
                                prop="receiptPhone"
                                rules={[
                                  ...inputRequired,
                                  {
                                    validator: validateTel,
                                    trigger: 'blur'
                                  }
                                ]}
                              >
                                <el-input
                                  v-model={item.receiptPhone}
                                  disabled={!isEdit}
                                />
                              </el-form-item>
                              <el-form-item
                                label="邮寄地址"
                                style={formItemStyle}
                                prop="receiptAddress"
                                maxlength="30"
                                rules={inputRequired}
                              >
                                <el-input
                                  v-model={item.receiptAddress}
                                  disabled={!isEdit}
                                />
                              </el-form-item>
                            </el-form>
                          </div>
                        );
                      })}
                      <el-button
                        type="text"
                        disabled={address.length >= maxCount || !isEdit}
                        onClick={() => {
                          address.push({
                            addressName: '',
                            receiptFullName: '',
                            receiptPhone: '',
                            receiptAddress: '',
                            isDefault: 0
                          });
                        }}
                      >
                        新增地址(最多{maxCount}条)
                      </el-button>
                    </div>
                  );
                }
              }
            }
          ]
        }
      ];
    }
  },
  methods: {
    saveInfo() {
      invoice.invoiceBaseInfo(this.formParams).then(res => {
        this.$message.success('保存成功');
        this.$xrkDialog.remove();
      });
    },
    checkForm(form) {
      return new Promise((resolve, reject) => {
        form.validate(vaild => {
          if (vaild) {
            resolve('ok');
          } else {
            reject('fail');
          }
        });
      });
    },
    edit() {
      if (this.isEdit) {
        // 保存
        const { form, addressForm } = this.$refs;
        Promise.all(
          Object.entries(addressForm[0].$refs).reduce(
            (pre, cur) => {
              pre.push(this.checkForm(cur[1]));
              return pre;
            },
            [this.checkForm(form)]
          )
        ).then(() => {
          if (
            (Array.isArray(this.formParams.address) &&
              this.formParams.address.length == 0) ||
            !this.formParams.address
          ) {
            this.$message.error('至少填写一个地址');
            return;
          }
          this.saveInfo();
          this.isEdit = false;
        });
      } else {
        this.isEdit = true;
      }
    }
  },
  async created() {
    const {
      data: { data }
    } = await invoice.getInvoiceBaseInfo();
    this.formParams = {
      address: [],
      ...data
    };
  }
};
</script>
<style lang="scss" scoped>
.box {
  .flex {
    display: flex;
    flex-wrap: wrap;
    .app-detail-item-title {
      width: 100%;
      margin-bottom: 30px;
    }
  }
  .el-form {
    &-item {
      width: 350px;
      margin-bottom: 45px;
    }
  }
}
</style>
